import window from '../injectChromeObject'
import { log } from '../misc'

const STORAGE_KEY = 'test'

export const canAccessWebLocalStorage = (): boolean => {
  try {
    window.localStorage.setItem(STORAGE_KEY, STORAGE_KEY)
    window.localStorage.removeItem(STORAGE_KEY)
    return true
  } catch {
    return false
  }
}

export const canAccessExtensionLocalStorage = async (): Promise<boolean> => {
  let canAccess = false
  if (window.chrome?.storage) {
    try {
      await window.chrome.storage.local.set({ [STORAGE_KEY]: STORAGE_KEY })
      await window.chrome.storage.local.remove(STORAGE_KEY)
      canAccess = true
    } catch (error) {
      if ((error as any).message?.includes('QUOTA_BYTES quota exceeded')) {
        canAccess = true
      }
    }
  }
  if (!canAccess) {
    log('canAccessExtensionLocalStorage:', canAccess)
  }
  return canAccess
}

export const canAccessLocalStorage = (() =>
  Boolean(window.chrome?.runtime?.id)
    ? canAccessExtensionLocalStorage
    : canAccessWebLocalStorage)()
